import React, { useState, useEffect, useRef } from "react";
import { useSelector, useDispatch } from "react-redux";
import journeyMapSlice from "../../store/journeyMap/journeyMapSlice";
import leaderboardSlice from "../../store/journeyMap/leaderboardSlice";
import { ProgramSetupAxios, UserActivityAxios, OnboardingAxios } from "../../API";
import Avatar from "../../shared/commonComponents/Avatar";
import CustomTable from "../../shared/customTable/customTable";
import { OverlayTrigger, Popover } from "react-bootstrap";
import authSlice from "../../store/auth/authSlice";
import FullReportDownload from "./FullReportDownload";
import { propTypes } from "react-bootstrap/esm/Image";


function Dashboard(props) {
  const dispatch = useDispatch();
  const journeyMap = useSelector((state) => state.journeyMapSlice.journeyMap);
  const leaderboard = useSelector((state) => state.leaderboardSlice.leaderboard);
  const allActivities = useSelector((state) => state.auth.missionDetails.tasks);
  const [journey, setJourney] = useState([...journeyMap]);
  const [progressIndicatorWidth, setProgressIndicatorWidth] = useState("0px");
  const [currentStage, setCurrentStage] = useState({});
  const [currentStageIndex, setCurrentStageIndex] = useState(0);
  const [nextStage, setNextStage] = useState({});
  const [nextActivityIndicator, setNextActivityIndicator] = useState("");
  const [coachJourneyData, setCoachJourneyData] = useState([]);

  const months = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sept",
    "Oct",
    "Nov",
    "Dec",
  ];

  const [stageDateMonth, setStageDateMonth] = useState("");
  const [stageDateDay, setStageDateDay] = useState("");
  const [individualLeaderboardTab, setIndividualLeaderboardTab] =
    useState("Program");
  const [teamLeaderboardTab, setTeamLeaderboardTab] = useState("Program");
  const userDetails = useSelector((state) => state.auth.loggedInUser);
  //const userTokenData = useSelector((state) => state.auth.tokenData);
  //let scrl = useRef(null);
  //const [scrollX, setscrollX] = useState(0);
  //const [scrolEnd, setscrolEnd] = useState(false);
  const [skillTable, setSkillTable] = useState([]);
  const [skillTableData, setSkillTableData] = useState([]);
  const [tableHeaders, setTableHeaders] = useState(["", "Team Members"]);
  const [tableData, setTableData] = useState([]);
  const [isJourneyDataSet, setJourneyDataSet] = useState(false);
  const [pdfData, setPdfData] = useState({});

  useEffect(() => {
    props.showSpinner(true);
  }, []);

  // useEffect(() => {
  //   console.log("leaderboard", leaderboard);
  //   console.log("journeyMap", Boolean(!leaderboard.programTopUsers || leaderboard.programTopUsers && leaderboard.programTopUsers.length == 0));


  // }, [leaderboard]);

  useEffect(() => {
    if (userDetails.roleId === 5) {
      props.setTourItem('coachDashbaord');
    }

  }, [userDetails]);

  useEffect(() => {
    if (userDetails.roleId === 5 && coachJourneyData.length > 0 && isJourneyDataSet === true) {
      let data = JSON.parse(JSON.stringify(journey));
      let coachdata = [...coachJourneyData];
      let tmp = coachdata.map(function (e) { return e.activityList; });
      coachdata = coachdata.map(function (e) { return e.activityList; });
      coachdata = coachdata.flat();
      coachdata = coachdata.filter(x => x.email == undefined);
      data.forEach((item, index, originalArray) => {
        let count = 0;
        let stageActivity = tmp[0].filter(x => x.stageId == item.stageId);
        stageActivity.forEach((element, childIndex, childOriginalArray) => {
          childOriginalArray[childIndex]['CompletedActivityCount'] = Math.round((coachdata.filter(x => x.activityId == element.activityId && x.isComplete == true).length) / (coachJourneyData.length));
        })
        originalArray[index]['stageActivity'] = stageActivity;
      })
      setJourney(data);
      setCurrentStage(data[0]);
      setCurrentStageIndex(data[0].sequence - 1);
      var startDateObj = new Date(data[0].startDate + "Z");
      var startMonth = startDateObj.getUTCMonth() + 1;
      var startDay = startDateObj.getUTCDate();
      var endDateObj = new Date(data[0].endDate + "Z");
      var endDay = endDateObj.getUTCDate();
      var dateStr = months[startMonth - 1];
      setStageDateMonth(dateStr);
      setStageDateDay(startDay + "-" + endDay);
      let progressIncatorWidth = 129 / data[0].totalActivityCount;
      setProgressIndicatorWidth(progressIncatorWidth + "px");

      data.forEach((element) => {
        if (element.isCurrent) {
          setCurrentStage(element);
          setCurrentStageIndex(element.sequence - 1);
          var startDateObj = new Date(element.startDate + "Z");
          var startMonth = startDateObj.getUTCMonth() + 1;
          var startDay = startDateObj.getUTCDate();
          var endDateObj = new Date(element.endDate + "Z");
          var endDay = endDateObj.getUTCDate();
          var dateStr = months[startMonth - 1];
          setStageDateMonth(dateStr);
          setStageDateDay(startDay + "-" + endDay);
          let progressIncatorWidth = 129 / element.totalActivityCount;
          setProgressIndicatorWidth(progressIncatorWidth + "px");
        }
      });
    }
  }, [coachJourneyData, isJourneyDataSet])

  useEffect(() => {

    ProgramSetupAxios.get(
      "/OfferingStage/getstagesbymission/" +
      userDetails.missionId +
      "/" +
      userDetails.offeringUserId
    )
      .then(function (response) {
        props.showSpinner(false);
        if (response && response.data.length > 0) {
          var data = response.data.sort((a, b) => a.sequence - b.sequence);
          dispatch(journeyMapSlice.actions.setJourneyMap(data));
          setJourney(data);
          setJourneyDataSet(true);
          if (userDetails.roleId !== 5) {
            setCurrentStage(data[0]);
            setCurrentStageIndex(data[0].sequence - 1);
            var startDateObj = new Date(data[0].startDate + "Z");
            var startMonth = startDateObj.getUTCMonth() + 1;
            var startDay = startDateObj.getUTCDate();
            var endDateObj = new Date(data[0].endDate + "Z");
            var endDay = endDateObj.getUTCDate();
            var dateStr = months[startMonth - 1];
            setStageDateMonth(dateStr);
            setStageDateDay(startDay + "-" + endDay);
            let isCurrent = false;
            let totalActivityCount = 1;
            data.forEach((element) => {
              totalActivityCount = element.totalActivityCount;
              if (element.isCurrent) {
                setCurrentStage(element);
                setCurrentStageIndex(element.sequence - 1);
                var startDateObj = new Date(element.startDate + "Z");
                var startMonth = startDateObj.getUTCMonth() + 1;
                var startDay = startDateObj.getUTCDate();
                var endDateObj = new Date(element.endDate + "Z");
                var endDay = endDateObj.getUTCDate();
                var dateStr = months[startMonth - 1];
                setStageDateMonth(dateStr);
                setStageDateDay(startDay + "-" + endDay);
                let progressIncatorWidth = 129 / element.totalActivityCount;
                setProgressIndicatorWidth(progressIncatorWidth + "px");
                let nextStageData = data.filter(
                  (x) => x.sequence == element.sequence + 1
                );
                if (nextStageData.length > 0) {
                  setNextStage(nextStageData[0]);
                } else {
                  setNextStage([]);
                }
                isCurrent = true;
              }

              if (element.IsNext) {
                setNextStage(element);
              }
            });

            if (isCurrent == false) {
              let progressIncatorWidth = 129 / totalActivityCount;
              setProgressIndicatorWidth(progressIncatorWidth + "px");
            }
          }
        }
      })
      .catch(function (error) {
        console.log(error);
      });


    if (userDetails.roleId !== 5) {
      var activityIds = allActivities.filter(x => x.activityTypeId === 1 || x.activityTypeId === 5).map(function (e) { return e.activityId; }).join(',');
      ProgramSetupAxios.get('/OfferingActivityFeedback/getofferingactivityfeedback/' + userDetails.offeringId)
        .then(function (res) {
          let tmp = [...res.data.filter(x => x.isActive).sort((a, b) => a.sortOrder - b.sortOrder).map(function (e) { return e.name; })];
          UserActivityAxios.get(`OfferingUserActivity/getskilltrajectory/${userDetails.offeringUserId}/${activityIds}`)
            .then(function (response) {
              if (response.data && response.data.length > 0) {
                response.data.sort((a, b) => (a.sequence > b.sequence) ? 1 : -1);
                let arr = response.data.map((item) => { return (item.coachFeedback != "" && item.coachFeedback != null && item.coachFeedback != undefined) ? JSON.parse(item.coachFeedback).feedback : []; });
                // tmp = tmp.map((e) => { return [e, 0] });
                tmp = tmp.map((e) => { return [e]; });
                tmp.forEach((item) => {
                  arr.forEach((innerItem) => {
                    if (innerItem.filter(x => x.name === item[0]).length > 0) {
                      if (innerItem.filter(x => x.name === item[0])[0].feedback.name !== "") {
                        item.push(parseInt(innerItem.filter(x => x.name === item[0])[0].feedback.value));
                      }
                      else {
                        item.push(0);
                      }
                    }
                    else if (innerItem.filter(x => x.Name === item[0]).length > 0) {
                      item.push(parseInt(innerItem.filter(x => x.Name === item[0])[0].Value));
                    }
                    else if (innerItem.length == 0) {
                      item.push(0);
                    }
                  });
                });

                let arr1 = ["Theme", "Self-rating", ...allActivities.filter(x => x.activityTypeId === 1).map(function (e) { return e.activityName; })];
                setSkillTable(arr1);
                console.log(arr1);
                setSkillTableData(tmp);

                let feedback = response.data.map(x => {
                  let feedback = null;
                  if (x.coachFeedback.trim().length > 0) {
                    let feed = JSON.parse(x.coachFeedback);
                    if (feed.note.length > 0) {
                      feedback = x.coachFeedback;
                    }
                  }

                  return { activityName: x.activityName, feedback: feedback };
                });

                let newFeedback = feedback.filter(x => Boolean(x.feedback));

                let pdfData = { headers: arr1, data: tmp, feedback: newFeedback };
                setPdfData(pdfData);
                console.log("pdfData", pdfData);
                console.log(tmp);
              }
              else {
                let arr1 = ["Theme", "Self-rating", ...allActivities.filter(x => x.activityTypeId === 1).map(function (e) { return e.activityName; })];
                setSkillTable(arr1);
                let tmp = [["Connect", 0, ...allActivities.filter(x => x.activityTypeId === 1).map(function (e) { return 0; })], ["Own", 0, ...allActivities.filter(x => x.activityTypeId === 1).map(function (e) { return 0; })], ["Solve", 0, ...allActivities.filter(x => x.activityTypeId === 1).map(function (e) { return 0; })], ["Communicate", 0, ...allActivities.filter(x => x.activityTypeId === 1).map(function (e) { return 0; })]];
                console.log(arr1);
                setSkillTableData(tmp);
                console.log(tmp);
              }
            })
            .catch(function (error) {
              console.log(error);
            });
        })
        .catch(function (error) {
          console.log(error);
        });
    }

    if (userDetails.roleId === 5) {
      OnboardingAxios.get(
        "OfferingUsers/getmyteamconnections/" + userDetails.offeringUserId
      ).then(function (response) {
        if (response.data.length > 0) {
          let teamMemberIds = response.data.filter(x => x.roleId !== 5).map(function (e) { return e.offeringUserId; }).join(',');
          UserActivityAxios.get(`OfferingUserActivity/coachteamprogress/${teamMemberIds}`)
            .then(function (response) {
              let teamMembersData = response.data;
              if (teamMembersData.length > 0) {
                //     let stageData = teamMembersData.map(function (e) { return e.activityList; });
                setCoachJourneyData(teamMembersData);
              }
              let tmp = [...tableHeaders];
              teamMembersData[0]["activityList"].forEach((item) => {
                tmp.push(item.activityName);
              });

              let arr = teamMembersData.map((item) => { return item.activityList; });
              teamMembersData.forEach((item, index) => {
                arr[index].unshift(item.userProfile);
                arr[index].unshift(item.userProfile);
              });

              setTableHeaders(tmp);
              setTableData(arr);
            })
            .catch(function (error) {
              console.log(error);
            });
        }
        else {
          if (journey.length > 0) {
            getJourneyDetails(journey[0]);
          }
        }
      });
    }

  }, [userDetails]);

  useEffect(() => {
    UserActivityAxios.get(
      `Leaderboard/getleaderboard/${userDetails.offeringId}/${userDetails.missionId}/${userDetails.teamId}`
    )
      .then(function (response) {
        // if response code is 204 then no data found
        if (response.status === 200) {
          dispatch(leaderboardSlice.actions.setLeaderboard(response.data));
        }
      })
      .catch(function (error) { console.log(error); });
  }, []);

  let groupBy = (array, key) => {
    return array.reduce((result, obj) => {
      (result[obj[key]] = result[obj[key]] || []).push(obj);
      return result;
    }, {});
  };

  const getJourneyDetails = (item) => {
    // if (userDetails.roleId === 5) {
    //   let count = 0;
    //   coachJourneyData.forEach((childItem, childIndex) => {
    //     count = count + childItem[item.stageId].filter(x => x.isComplete).length;
    //   });
    //   item['completedActivityCount'] = Math.round(count / coachJourneyData.length);
    // }
    setCurrentStage(item);
    setCurrentStageIndex(item.sequence - 1);
    var startDateObj = new Date(item.startDate + "Z");
    var startMonth = startDateObj.getUTCMonth() + 1;
    var startDay = startDateObj.getUTCDate();
    var endDateObj = new Date(item.endDate + "Z");
    var endDay = endDateObj.getUTCDate();
    var dateStr = months[startMonth - 1];
    setStageDateMonth(dateStr);
    setStageDateDay(startDay + "-" + endDay);
    let progressIncatorWidth = 129 / item.totalActivityCount;
    setProgressIndicatorWidth(progressIncatorWidth + "px");
    let nextStageData = journey.filter((x) => x.sequence == item.sequence + 1);
    if (nextStageData.length > 0) {
      setNextStage(nextStageData[0]);
    } else {
      setNextStage([]);
    }
  };

  const toggleNextStageInfo = (str, item) => {
    if (item.stageName === nextStage.stageName) {
      setNextActivityIndicator("");
      return;
    }

    if (str == "enter") setNextActivityIndicator("hideNextStageContent");
    else setNextActivityIndicator("");
  };

  const [programTopUser, setProgramTopUser] = useState({});

  const popover = (
    <Popover id="popover-basic" className="profilePopover">
      <div className="popover-profile-top-section">
        {/* <div className="profile-picture">
          <div className="profile-avatar">
          <UserThumbnail currentUser={true} className="profile-avatar" />
          </div>
        </div> */}
        <Avatar {...programTopUser?.userPorfile} className="small" />
        <div className="profile-details">
          <div className="profile-name">
            {programTopUser?.userPorfile?.firstName + " " + programTopUser?.userPorfile?.lastName}
          </div>
          <div className="profile-teamname">{programTopUser?.userPorfile?.teamName}</div>
          <div className="profile-missionname">{programTopUser?.userPorfile?.missionName}</div>
        </div>
      </div>
      <div className="popover-profile-bottom-section">
        <div className="profile-email">{programTopUser?.userPorfile?.email}</div>
        <div
          className="profile-view"
          onClick={() => {
            openProfile(programTopUser?.userId, programTopUser?.offeringUserId);
          }}
        >
          View Profile
        </div>
      </div>
    </Popover>
  );

  const openProfile = (userid, offeringuserid) => {
    dispatch(
      authSlice.actions.setProfileData({
        userId: userid,
        offeringUserId: offeringuserid,
      })
    );
    dispatch(
      authSlice.actions.setProfileStack({
        userId: userid,
        offeringUserId: offeringuserid,
      })
    );
    dispatch(authSlice.actions.setProfileLoader({ showLoader: true }));
    dispatch(authSlice.actions.showProfile());
    setTimeout(function () {
      dispatch(authSlice.actions.setProfileLoader({ showLoader: false }));
    }, 2000);
  };


  // function IsJsonString(str) {
  //   try {
  //     var temp = JSON.parse(str);
  //   } catch (e) {
  //     return false;
  //   }
  //   return true;
  // }

  function getFrame(data) {

    if (data && data.userPorfile && data.userPorfile.currentLevel === 0) {
      return "normal-frame";
    }
    if (data && data.userPorfile && data.userPorfile.currentLevel === 1) {
      return "bronze-frame";
    }
    if (data && data.userPorfile && data.userPorfile.currentLevel === 2) {
      return "silver-frame";
    }
    if (data && data.userPorfile && data.userPorfile.currentLevel === 3) {
      return "gold-frame";
    }
    if (data && data.userPorfile && data.userPorfile.currentLevel === 4) {
      return "platinum-frame";
    }
  }

  return (
    <>
      <div className="dashboard_container vertical-scroll1">
        <div className="dashboardChild_container">
          <div className="onboarding_headerContainer">
            <div className="onboarding_headerOutline">
              <div className="onboarding_header"> {currentStage.stageName}</div>
            </div>
            {/* <div className="onboarding_header_label" ref={ref3}>{currentStage.StageName}</div> */}
            <div className="programDate">
              {stageDateMonth}
              <span>{stageDateDay}</span>
            </div>
          </div>
          <div style={{ position: "relative" }}>
            {/* {currentStage.isUnlocked && currentStage.isComplete &&
              <div className="completedJourneyIcon">
                <div className="completedCheckmarkIcon"></div>
              </div>
            } */}
            {/* {currentStage.isUnlocked && !currentStage.isComplete &&
              <div className="inCompltedJourneyIcon"></div>
            } */}
            <div className="onboardingOverview_box">
              {!currentStage.isUnlocked && (
                <div className="stageLockIcon"></div>
              )}
              {/* <div className="onboardingOverview_gridlines"> */}
              <div className="onboarding_overview_label">Overview</div>
              <div className="onboarding_overview_desc">
                {currentStage.shortDescription}
              </div>
              <div className="progressStatus">Progress status:</div>
              {/* </div> */}
            </div>
            <div className="stageProgress">
              {/* journey.map((item, index) => { */}
              {Array.from(Array(currentStage.totalActivityCount), (e, i) => {
                return (
                  <>
                    {userDetails.roleId === 5 &&
                      <div
                        key={"stageProgress" + i}
                        className={`progressIndicator ${currentStage && currentStage.stageActivity && currentStage.stageActivity[i]['CompletedActivityCount'] == 1
                          ? "active"
                          : ""
                          }`}
                        style={{ width: progressIndicatorWidth }}
                      ></div>}
                    {userDetails.roleId !== 5 &&
                      <div
                        key={"stageProgress" + i}
                        className={`progressIndicator ${currentStage.completedActivityCount >= i + 1
                          ? "active"
                          : ""
                          }`}
                        style={{ width: progressIndicatorWidth }}
                      ></div>}
                  </>
                );
              })}
            </div>
          </div>
        </div>

        <div className="journeyMapContainer">
          <div className="journeyBg"></div>
          <div className="line">
            <div className="background"></div>
            <div className="mesh-blank"></div>
            <div className="background"></div>
          </div>
          <div className="activityContainer">
            <div className="left-container">
              {journey.map((item, index) => {
                return (
                  <>
                    {currentStageIndex > index && (
                      // <div className={"activityIndicator " + (item.StageName == nextStage.StageName ? nextActivityIndicator : '')} onClick={() => getJourneyDetails(item)}>
                      <div
                        className={`activityWrapper ${item.stageName === nextStage.stageName
                          ? "nextStage"
                          : ""
                          }`}
                        key={"r55" + index}
                      >
                        <div className="indicatorStatus">
                          <div className="stageName">
                            <div className={`stageLabel`}>{item.stageName}</div>
                          </div>
                          {!item.isUnlocked && <div className="lockIcon"></div>}
                          <div
                            className={`statusBar  ${item.isComplete ? "completedStatusBar" : ""
                              }`}
                          ></div>
                        </div>
                        <div
                          key={"journey1" + item.id}
                          className="activityIndicator_container"
                        >
                          <div
                            key={"stage" + item.id}
                            className={"activityIndicator"}
                            onClick={() => getJourneyDetails(item)}
                          >
                            {!item.isComplete && (
                              <div className="journey">
                                <div className="journeyRing"></div>
                                <div className="journeyDot"></div>
                              </div>
                            )}
                            {item.isComplete && (
                              <div className="completedJourney">
                                <div className="completedJourneyOutline"></div>
                                <div className="completedCheckmark"></div>
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                    )}
                  </>
                );
              })}
            </div>
            <div className="mesh-container">
              <div className="mesh-indicator">
                <div className="dot"></div>
              </div>
              <div className="mesh"></div>
            </div>
            <div className="right-container">
              {journey.map((item, index) => {
                return (
                  <>
                    {currentStageIndex < index && (
                      <div
                        key={"r65" + index}
                        onMouseEnter={() => {
                          toggleNextStageInfo("enter", item);
                        }}
                        onMouseLeave={() => {
                          toggleNextStageInfo("leave", item);
                        }}
                        className={`activityWrapper ${item.stageName === nextStage.stageName
                          ? "nextStage"
                          : ""
                          }`}
                      >
                        <div
                          className={`indicatorStatus ${nextActivityIndicator}`}
                        >
                          <div className="stageName">
                            <div className="stageLabel">{item.stageName}</div>
                          </div>
                          {!item.isUnlocked && <div className="lockIcon"></div>}
                          <div className="statusBar"></div>
                        </div>
                        <div
                          key={"journey2" + item.id}
                          className="activityIndicator_container"
                        >
                          <div
                            className={"activityIndicator"}
                            onClick={() => getJourneyDetails(item)}
                          >
                            {!item.isComplete && (
                              <div className="journey">
                                <div className="journeyRing"></div>
                                <div className="journeyDot"></div>
                              </div>
                            )}
                            {item.isComplete && (
                              <div className="completedJourney">
                                <div className="completedJourneyOutline"></div>
                                <div className="completedCheckmark"></div>
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                    )}
                  </>
                );
              })}
            </div>
          </div>
        </div>
        {/* {userDetails.roleId !== 5 && skillTable && skillTable.length > 0 && skillTableData && skillTableData.length > 0 &&
          <div className="skill-trajectory-container">
            <div className="skill-trajectory-header">
              <div className="wings"></div>
              <div className="header-text"><nobr>Your Skill Trajectory</nobr></div>
              <div className="wings"></div>
            </div>
            <div className="skill-trajectory-content">
              {skillTable && skillTable.length > 0 && skillTableData && skillTableData.length > 0 && <CustomTable
                className="custom-skill-table-container"
                isSkill={true}
                headers={skillTable}
                data={skillTableData}
                frozen={1}
                roleId={userDetails.roleId}
              />}
              <div className="skill-trajectory-action">
                <div className="skill-trajectory-action-text">
                  Click to download a detailed report.
                </div>
                <FullReportDownload
                  pdfData={pdfData}
                  skillHeader={skillTable}
                  skillData={skillTableData}
                  userName={userDetails.firstName + " " + userDetails.lastName}
                  location={userDetails.location}
                />

              </div>
            </div>
          </div>
        }
         */}
        {userDetails.roleId === 5 && tableData && tableData.length > 0 &&
          tableHeaders && tableHeaders.length > 1 &&
          <CustomTable
            className="custom-activity-table-container"
            isSkill={false}
            headers={tableHeaders}
            data={tableData}
            frozen={2}
            roleId={userDetails.roleId} />
        }

        {/* <div className="dashboard_leaderboard_container">
          {userDetails.roleId !== 5 && (
            <>
              <div className="individual_leaderboard">
                <div className="leaderboard_header">
                  <div className="leaderboard_header_label">
                    Individual Leaderboard
                  </div>
                </div>
                <div className="leaderboard_body">
                  <div className="leaderboard_tabs">
                    <div
                      className={`leaderboard_tab_label ${individualLeaderboardTab === "Program" ? "active" : ""
                        }`}
                      onClick={() => {
                        setIndividualLeaderboardTab("Program");
                      }}
                    >
                      Program
                    </div>
                    <div
                      className={`leaderboard_tab_label ${individualLeaderboardTab === "Your Team" ? "active" : ""
                        }`}
                      onClick={() => {
                        setIndividualLeaderboardTab("Your Team");
                      }}
                    >
                      Your Team
                    </div>
                  </div>
                  <div className="leaderboard_tabs_line">
                    <div
                      className={`leaderboard_tab_label_line ${individualLeaderboardTab === "Program" ? "active" : ""
                        }`}
                    ></div>
                    <div
                      className={`leaderboard_tab_label_line ${individualLeaderboardTab === "Your Team" ? "active" : ""
                        }`}
                    ></div>
                  </div>
                  <div className="tabBody">
                    {individualLeaderboardTab == "Program" && (
                      <div className="programTab">
                        {Boolean(!leaderboard.programTopUsers || leaderboard.programTopUsers && leaderboard.programTopUsers.length == 0) &&
                          <div className="corner-border mt-2">
                            <div className="nodata-found">Data not available.</div>
                          </div>
                        }
                        <div className="rank-member">
                          {leaderboard &&
                            leaderboard.programTopUsers &&
                            leaderboard.programTopUsers[1] && (
                              <div className="rank-2">
                                <div className="rank-avatar">
                                  <Avatar
                                    className="medium"
                                    {...leaderboard.programTopUsers[1].userPorfile}
                                    profileImage={leaderboard.programTopUsers[1].imageUrl}

                                  />
                                  
                                  <div className="frame-rank">
                                    0{leaderboard.programTopUsers[1].rank}
                                  </div>
                                </div>

                                <OverlayTrigger
                                  trigger="click"
                                  placement="top"
                                  overlay={popover}
                                  rootClose
                                >
                                  <div className="rankHolderName" onClick={() => { setProgramTopUser(leaderboard.programTopUsers[1]); }}>
                                    {leaderboard.programTopUsers[1].name}
                                  </div>
                                </OverlayTrigger>
                                <div className="rankHolderPoints f-11">
                                  {leaderboard.programTopUsers[1].points} Pts
                                </div>
                              </div>
                            )}
                          {leaderboard &&
                            leaderboard.programTopUsers &&
                            leaderboard.programTopUsers[0] && (
                              <div className="rank-1">
                                <div className="rank-avatar">
                                  <Avatar
                                    className="x-large"
                                    {...leaderboard.programTopUsers[0].userPorfile}
                                    profileImage={leaderboard.programTopUsers[0].imageUrl}
                                  />
                                 
                                  <div className="frame-rank">
                                    0{leaderboard.programTopUsers[0].rank}
                                  </div>
                                </div>
                                <OverlayTrigger
                                  trigger="click"
                                  placement="top"
                                  overlay={popover}
                                  rootClose
                                >
                                  <div className="rankHolderName" onClick={() => { setProgramTopUser(leaderboard.programTopUsers[0]); }}>
                                    {leaderboard.programTopUsers[0].name}
                                  </div>
                                </OverlayTrigger>
                                <div className="rankHolderPoints">
                                  {leaderboard.programTopUsers[0].points} Pts
                                </div>
                              </div>
                            )}

                          {leaderboard &&
                            leaderboard.programTopUsers &&
                            leaderboard.programTopUsers[2] && (
                              <div className="rank-3">
                                <div className="rank-avatar">
                                  <Avatar
                                    className="medium"
                                    {...leaderboard.programTopUsers[2].userPorfile}
                                    profileImage={leaderboard.programTopUsers[2].imageUrl}

                                  />
                                  
                                  <div className="frame-rank">
                                    0{leaderboard.programTopUsers[2].rank}
                                  </div>
                                </div>
                                <OverlayTrigger
                                  trigger="click"
                                  placement="top"
                                  overlay={popover}
                                  rootClose
                                >
                                  <div className="rankHolderName" onClick={() => { setProgramTopUser(leaderboard.programTopUsers[2]); }}>
                                    {leaderboard.programTopUsers[2].name}
                                  </div>
                                </OverlayTrigger>
                                <div className="rankHolderPoints f-11">
                                  {leaderboard.programTopUsers[2].points} Pts
                                </div>
                              </div>
                            )}
                        </div>
                        <div className="your-team">
                          {leaderboard &&
                            leaderboard.yourTeam &&
                            leaderboard.yourTeam.map((item, index) => {
                              return (
                                <>
                                  {item.userId === userDetails.userId && (
                                    <div className="corner-border" key={"r1vxc90" + index}>
                                      <div className="teamInfo">
                                        <span className="team-rank">
                                          {item.rank}
                                        </span>
                                        <span className="team-name">You</span>
                                        <div className="team_points">
                                          {item.points} Pts
                                        </div>
                                      </div>
                                    </div>
                                  )}
                                </>
                              );
                            })}
                        </div>
                      </div>
                    )}
                    {individualLeaderboardTab == "Your Team" && (
                      <div className="missionTab">
                        <div className="team-list">
                          {leaderboard &&
                            leaderboard.yourTeam &&
                            leaderboard.yourTeam.map((item, index) => {
                              return (
                                <>
                                  <div className="corner-border" key={"r75" + index}>
                                    <div className="teamInfo">
                                      <span className="team-rank">
                                        {item.rank}
                                      </span>
                                      <span className="team-name">
                                        {item.name}
                                      </span>
                                      <div className="team_points">
                                        {item.points} Pts
                                      </div>
                                    </div>
                                  </div>
                                </>
                              );
                            })}
                          {Boolean(!leaderboard.yourTeam || leaderboard.yourTeam && leaderboard.yourTeam.length == 0) &&
                            <div className="corner-border">
                              <div className="nodata-found">Data not available.</div>
                            </div>
                          }
                        </div>
                        <div className="your-team" style={{ marginTop: "20px" }}>
                          {leaderboard &&
                            leaderboard.yourTeam &&
                            leaderboard.yourTeam.map((item, index) => {
                              return (
                                <>
                                  {item.userId === userDetails.userId && (
                                    <div className="corner-border" key={"r1vxc90" + index}>
                                      <div className="teamInfo">
                                        <span className="team-rank">
                                          {item.rank}
                                        </span>
                                        <span className="team-name">You</span>
                                        <div className="team_points">
                                          {item.points} Pts
                                        </div>
                                      </div>
                                    </div>
                                  )}
                                </>
                              );
                            })}
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </div>

              <div className="team_leaderboard">
                <div className="leaderboard_header">
                  <div className="leaderboard_header_label">
                    Team Leaderboard
                  </div>
                </div>
                <div className="leaderboard_body">
                  <div className="leaderboard_tabs">
                    <div
                      className={`leaderboard_tab_label ${teamLeaderboardTab === "Program" ? "active" : ""
                        }`}
                      onClick={() => {
                        setTeamLeaderboardTab("Program");
                      }}
                    >
                      Program
                    </div>
                    <div
                      className={`leaderboard_tab_label ${teamLeaderboardTab === "Mission" ? "active" : ""
                        }`}
                      onClick={() => {
                        setTeamLeaderboardTab("Mission");
                      }}
                    >
                      Mission
                    </div>
                  </div>
                  <div className="leaderboard_tabs_line">
                    <div
                      className={`leaderboard_tab_label_line ${teamLeaderboardTab === "Program" ? "active" : ""
                        }`}
                    ></div>
                    <div
                      className={`leaderboard_tab_label_line ${teamLeaderboardTab === "Mission" ? "active" : ""
                        }`}
                    ></div>
                  </div>
                  <div className="tabBody">
                    {teamLeaderboardTab == "Program" && (
                      <div className="programTab">
                        <div className="team-list">
                          {leaderboard &&
                            leaderboard.programTopTeams &&
                            leaderboard.programTopTeams.map((item, index) => {
                              return (
                                <>
                                  <div className="corner-border" key={"r854" + index}>
                                    <div className="teamInfo">
                                      <span className="team-rank">
                                        {item.rank}
                                      </span>
                                      <span className="team-name">
                                        {item.name}
                                      </span>
                                      <div className="team_points">
                                        {item.points} Pts
                                      </div>
                                    </div>
                                  </div>
                                </>
                              );
                            })}
                          {Boolean(!leaderboard.programTopTeams || leaderboard.programTopTeams && leaderboard.programTopTeams.length == 0) &&
                            <div className="corner-border">
                              <div className="nodata-found">Data not available.</div>
                            </div>
                          }
                        </div>
                        <div className="your-team" style={{ marginTop: "20px" }}>
                          {leaderboard &&
                            leaderboard.programTopTeams &&
                            leaderboard.programTopTeams.map((item, index) => {
                              return (
                                <>
                                  {item.teamId === userDetails.teamId && (
                                    <div className="corner-border" key={"asd" + index}>
                                      <div className="teamInfo">
                                        <span className="team-rank">
                                          {item.rank}
                                        </span>
                                        <span className="team-name">
                                          Your Team
                                        </span>
                                        <div className="team_points">
                                          {item.points} Pts
                                        </div>
                                      </div>
                                    </div>
                                  )}
                                </>
                              );
                            })}

                        </div>
                      </div>
                    )}
                    {teamLeaderboardTab == "Mission" && (
                      <div className="missionTab">
                        <div className="team-list">
                          {leaderboard &&
                            leaderboard.missionTopTeams &&
                            leaderboard.missionTopTeams.map((item, index) => {
                              return (
                                <>
                                  <div className="corner-border" key={"r49" + index}>
                                    <div className="teamInfo">
                                      <span className="team-rank">
                                        {item.rank}
                                      </span>
                                      <span className="team-name">
                                        {item.name}
                                      </span>
                                      <div className="team_points">
                                        {item.points} Pts
                                      </div>
                                    </div>
                                  </div>
                                </>
                              );
                            })}
                          {Boolean(!leaderboard.missionTopTeams || leaderboard.missionTopTeams && leaderboard.missionTopTeams.length == 0) &&
                            <div className="corner-border">
                              <div className="nodata-found">Data not available.</div>
                            </div>
                          }
                        </div>
                        <div className="your-team" style={{ marginTop: "20px" }}>
                          {leaderboard &&
                            leaderboard.missionTopTeams &&
                            leaderboard.missionTopTeams.map((item, index) => {
                              return (
                                <>
                                  {item.teamId === userDetails.teamId && (
                                    <div
                                      className="corner-border"
                                      key={"r1440" + index}
                                    >
                                      <div className="teamInfo">
                                        <span className="team-rank">
                                          {item.rank}
                                        </span>
                                        <span className="team-name">
                                          Your Team
                                        </span>
                                        <div className="team_points">
                                          {item.points} Pts
                                        </div>
                                      </div>
                                    </div>
                                  )}
                                </>
                              );
                            })}

                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </>
          )}
          {userDetails.roleId == 5 && (
            <div className="team_leaderboard coach">
              <div className="leaderboard_header">
                <div className="leaderboard_header_label">Team Leaderboard</div>
              </div>
              <div className="leaderboard_body coach">
                <div className="leaderboard_tabs leaderboard_tabs_coach">
                  <div className={`leaderboard_tab_label program_coach`}>
                    Program
                  </div>
                  <div className={`leaderboard_tab_label mission_coach`}>
                    Mission
                  </div>
                </div>
                <div className="leaderboard_tabs_line_container">
                  <div className="leaderboard_tabs_line program_coach"></div>
                  <div className="leaderboard_tabs_line mission_coach"></div>
                </div>
                <div className="tabBody">
                  <div className="programTab">
                    <div className="team-list">
                      {leaderboard &&
                        leaderboard.programTopTeams &&
                        leaderboard.programTopTeams.map((item, index) => {
                          return (
                            <>
                              <div className="corner-border" key={"r188" + index}>
                                <div className="teamInfo">
                                  <span className="team-rank">{item.rank}</span>
                                  <span className="team-name">{item.name}</span>
                                  <div className="team_points">
                                    {item.points} Pts
                                  </div>
                                </div>
                              </div>
                            </>
                          );
                        })}
                      {Boolean(!leaderboard.programTopTeams || leaderboard.programTopTeams && leaderboard.programTopTeams.length == 0) &&
                        <div className="corner-border">
                          <div className="nodata-found">Data not available.</div>
                        </div>
                      }
                    </div>
                    <div className="your-team">
                      {leaderboard &&
                        leaderboard.programTopTeams &&
                        leaderboard.programTopTeams.map((item, index) => {
                          return (
                            <>
                              {item.teamId === userDetails.teamId && (
                                <div className="corner-border" key={"wew" + index}>
                                  <div className="teamInfo">
                                    <span className="team-rank">
                                      {item.rank}
                                    </span>
                                    <span className="team-name">Your Team</span>
                                    <div className="team_points">
                                      {item.points} Pts
                                    </div>
                                  </div>
                                </div>
                              )}
                            </>
                          );
                        })}

                    </div>
                  </div>
                  <div className="missionTab">
                    <div className="team-list">
                      {leaderboard &&
                        leaderboard.missionTopTeams &&
                        leaderboard.missionTopTeams.map((item, index) => {
                          return (
                            <>
                              <div className="corner-border" key={"1r99" + index}>
                                <div className="teamInfo">
                                  <span className="team-rank">{item.rank}</span>
                                  <span className="team-name">{item.name}</span>
                                  <div className="team_points">
                                    {item.points} Pts
                                  </div>
                                </div>
                              </div>
                            </>
                          );
                        })}
                      {Boolean(!leaderboard.missionTopTeams || leaderboard.missionTopTeams && leaderboard.missionTopTeams.length == 0) &&
                        <div className="corner-border">
                          <div className="nodata-found">Data not available.</div>
                        </div>
                      }
                    </div>
                    <div className="your-team">
                      {leaderboard &&
                        leaderboard.missionTopTeams &&
                        leaderboard.missionTopTeams.map((item, index) => {
                          return (
                            <>
                              {item.teamId === userDetails.teamId && (
                                <div className="corner-border" key={"r190" + index}>
                                  <div className="teamInfo">
                                    <span className="team-rank">
                                      {item.rank}
                                    </span>
                                    <span className="team-name">Your Team</span>
                                    <div className="team_points">
                                      {item.points} Pts
                                    </div>
                                  </div>
                                </div>
                              )}
                            </>
                          );
                        })}

                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div> */}
     
      </div>
    </>
  );
}

export default Dashboard;
